import { render } from "./WatchlistEditor.vue?vue&type=template&id=8a7c2fda&scoped=true"
import script from "./WatchlistEditor.vue?vue&type=script&lang=js"
export * from "./WatchlistEditor.vue?vue&type=script&lang=js"

import "./WatchlistEditor.vue?vue&type=style&index=0&id=8a7c2fda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a7c2fda"]])

export default __exports__